module.exports = __webpack_public_path__ + "static/media/battle.7bc1d96f.svg";